// extracted by mini-css-extract-plugin
module.exports = {"cookieRequest":"allowCookies_cookieRequest__1v5He","textBox":"allowCookies_textBox__1zR4K","text":"allowCookies_text__3Vtrr","button":"allowCookies_button__10__h"};